<template>
  <div>
    <div class="_root">
      <div class="_column">
        <div class="_cachet">
          · <span style="padding: 0 0.06rem">出生</span> ·
        </div>
        <div>
          <div style="margin-bottom: 0.18rem">
            阳历: {{ orderInfo.yangli_year }}-{{ orderInfo.yangli_month }}-{{orderInfo.yangli_day}}
             <span v-if="orderInfo.hour">{{ orderInfo.hour }}时</span>
          </div>
          <div>
            阴历: {{ orderInfo.yinli_year }}-{{ orderInfo.yinli_month }}-{{orderInfo.yinli_day}}
            <span v-if="orderInfo.hour">{{ orderInfo.hour }}时</span>
          </div>
        </div>
      </div>

      <div class="_column-sec">
        <div class="_cachet">
          · <span style="padding: 0 0.06rem" v-if="orderInfo.hour">四柱</span> ·
		  · <span style="padding: 0 0.06rem" v-else>三柱</span> ·
        </div>
        <div>{{ orderInfo.sizhu }}</div>
      </div>

      <div class="_column-sec">
        <div class="_cachet">
          · <span style="padding: 0 0.06rem">性别</span> ·
        </div>
        <div>{{ orderInfo.gender }}</div>
      </div>

      <div class="_tips">{{ "阴阳五行（过而不及，即为病变）" }}</div>

      <div class="table" style="width: 100%">
        <div class="th">
          <div class="td">阴 (脏)</div>
          <div class="td">阳 (腑)</div>
          <div class="td">五行</div>
          <div class="td">总数</div>
          <div class="td">结果</div>
        </div>
        <!-- 遍历 -->
        <div
          class="th"
          v-for="(item, index) in orderInfo.result.wuxing"
          :key="index"
        >
          <div class="td" v-for="(val, idx) in item" :key="idx">{{ val }}</div>
        </div>
      </div>

      <div style="display: flex; padding: 0.4rem 0; font-size: 0.28rem">
        <div class="_big-cachet">
          · <span style="padding: 0 0.06rem">结果</span> ·
        </div>
      </div>
      <div class="_list" v-html="orderInfo.result.result"></div>
<!--      <div  @click="openModal2()" style="width: 100%; height: 40px; line-height: 40px; font-size: 18px; text-align: center;border: #7C4D4E 1px solid; margin-top: 20px;">解刨结果</div>-->
      <div style="position: relative; margin-top: 20px;">
        <div style=""><img src="https://sz.daolongsz.com/static/report_routine_qrcode_bg.png" style="width: 100%; height:100%;"/></div>
        <div style="width:120px;margin: 20px auto; "><img src="https://sz.daolongsz.com/static/report_routine_qrcode.png" style="width: 120px;height: 120px;position: absolute; top: 20px; left: 20px;"/></div>
      </div>

    </div>
    <div style="position: fixed; right: 20px; bottom: 70px; width: 75px; height: 75px; z-index: 99;" @click="openModal()">
        <img src="https://sz.daolongsz.com/static/chayin.png" style="width: 100%; height: 100%;">
    </div>

    <div id="myModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <p><img src="https://sz.daolongsz.com/static/routine.png" style="width: 250px; height: 250px"></p>
        <p style="text-align: center;font-size: 16px;color: #F00; margin-top: 10px">长按识别小程序码进入饮茶介绍</p>
      </div>
    </div>
    <div id="myModal2" class="modal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <p><img :src="orderInfo.service_qrcode" style="width: 250px; height: 250px"></p>
        <p style="text-align: center;font-size: 16px;color: #F00; margin-top: 10px">通过二维码添加客服,下完成报告解析</p>
      </div>
    </div>
  </div>
</template>
  
  <script>
	  import { getSizhuOrderDetail } from "@api/order";
export default {
	
  data: function () {
    return {
		orderInfo:{},
		id: this.$route.params.id,
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
		  console.log(n.params);
        this.id = n.params.id;
        this.getDetail();
      }
    }
  },
  created() {
	  this.$router.push('/');
  },
  mounted: function () {
	  this.getDetail();
  },
  methods: {
	  getDetail() {
	    const id = this.id;
	    if (!id) return this.$dialog.error("订单不存在");
	    getSizhuOrderDetail(id)
	      .then(res => {
	        this.orderInfo = res.data;
	      })
	      .catch(err => {
	        this.$dialog.error(err.msg);
	        this.$router.go(-1);
	      });
	  },
    openModal(){
      // 获取模态框和关闭按钮，并添加点击事件监听器来显示和隐藏模态框
      var modal = document.getElementById("myModal");
      console.log(123123);
      modal.style.display = "block"; // 显示模态框
    },
    openModal2(){
      // 获取模态框和关闭按钮，并添加点击事件监听器来显示和隐藏模态框
      var modal = document.getElementById("myModal2");
      console.log(123123);
      modal.style.display = "block"; // 显示模态框
    },
    closeModal(){
      // 获取模态框和关闭按钮，并添加点击事件监听器来显示和隐藏模态框
      var modal = document.getElementById("myModal");
      var modal2 = document.getElementById("myModal2");
      console.log(123123);
      modal.style.display = "none"; // 显示模态框
      modal2.style.display = "none"; // 显示模态框
    },
  },

};

    // // 获取模态框和关闭按钮，并添加点击事件监听器来显示和隐藏模态框
    // var modal = document.getElementById("myModal");
    // var btn = document.getElementsByClassName("close")[0]; // 获取关闭按钮元素（假设只有一个关闭按钮）
    // var span = document.getElementsByClassName("close")[0]; // 获取关闭按钮元素（假设只有一个关闭按钮）用于关闭弹窗的点击事件处理
    //
    // // 点击按钮显示模态框
    // btn.onclick = function() {
    //   modal.style.display = "block"; // 显示模态框
    // }
    //
    // // 点击X按钮关闭模态框或点击外部区域关闭模态框（可选）
    // span.onclick = function() {
    //   modal.style.display = "none"; // 隐藏模态框
    // }
    //
    // // 点击窗口外部区域关闭模态框（可选）
    // window.onclick = function(event) {
    //   if (event.target == modal) { // 如果点击的是模态框本身（不包括内容区域）则关闭它。注意这里用的是event.target而不是直接用modal对象，因为直接用modal对象在某些情况下可能不会触发。为了确保兼容性，通常使用event.target。
    //     modal.style.display = "none"; // 隐藏模态框
    //   }
    // }
</script>
  
<style scoped>
.td {
  flex: 1;
  padding: 0.2rem 0;
  border-right: 1px solid #666;
  border-right: 1px solid #666;
}
.th .td:first-child {
  border-left: 1px solid #666;
}
.th {
  border-top: 1px solid #666;
  border-bottom: 1px solid #666;
  display: flex;
  text-align: center;
  width: 100%;
}
.table .th {
  background-color: #fff;
  color: #b18a67;
  margin-top: -1px;
}
.table .th:first-child {
  background-color: #b18a67 !important;
  color: #fff !important;
}
.table {
  font-size: 0.28rem;
}

._root {
  padding: 0 0.2rem 2rem;
  background-color: #fff;
  min-height: 100vh;
}
._banner {
  width: 100%;
  height: 2rem;
  border-radius: 0.16rem;
  margin-top: 0.2rem;
}
._column {
  padding: 0.3rem;
  background-color: rgb(241, 241, 241);
  border-radius: 0.16rem;
  margin-top: 0.6rem;
  display: flex;
  align-items: center;
  font-size: 0.28rem;
}
._column-sec {
  padding: 0.3rem;
  background-color: rgb(241, 241, 241);
  border-radius: 0.16rem;
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  font-size: 0.28rem;
}
._cachet {
  background-color: #b18a67;
  color: #fff;
  margin-right: 0.2rem;
  padding: 0.1rem 0.2rem;
  border-radius: 2rem;
}
._tips {
  width: 100%;
  padding: 0.4rem 0;
  font-size: 0.32rem;
  color: #b18a67;
  text-align: center;
}
._big-cachet {
  background-color: #b18a67;
  color: #fff;
  margin-right: 0.2rem;
  padding: 0.1rem 0.8rem;
  border-radius: 2rem;
}
._list {
  padding: 0.2rem 0.3rem 0.6rem;
  background-color: rgb(241, 241, 241);
  border-radius: 0.16rem;
  font-size: 0.28rem;
}
._list-item {
  border-bottom: 1px solid #000;
  padding: 0.3rem 0;
}
._btn-box {
  padding: 0.4rem 0.2rem;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
}
._btn {
  background-color: rgb(236, 212, 147);
  text-align: center;
  font-weight: 550;
  color: rgb(114, 90, 47);
  font-size: 0.34rem;
  border-radius: 2rem;
  padding: 0.2rem 0;
}


/* 模态框（背景） */
.modal {
  display: none; /* 默认隐藏 */
  position: fixed; /* 固定定位 */
  z-index: 1; /* 置于顶层 */
  left: 0;
  top: 0;
  width: 100%; /* 全宽 */
  height: 100%; /* 全高 */
  overflow: auto; /* 启用滚动 */
  background-color: rgb(0,0,0); /* 背景颜色 */
  background-color: rgba(0,0,0,0.4); /* 背景颜色，带透明度 */
}

/* 模态框内容 */
.modal-content {
  background-color: #fefefe;
  margin: 45% auto; /* 15% 从顶部和自动水平居中 */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* 可根据需要调整宽度 */
}

/* 关闭按钮 */
.close {
  color: #aaa;
  float: right;
  font-size: 32px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>